import React from "react";

const DashboardIcon = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask id="mask0_1632_253" x="0" y="0" width="25" height="25">
        <rect width="25" height="25" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_1632_253)">
        <path
          d="M10.8856 16.1459C11.3196 16.5799 11.8665 16.7839 12.5262 16.7579C13.1859 16.7319 13.6634 16.4931 13.9585 16.0417L18.3595 9.45321C18.5158 9.21015 18.4941 8.9888 18.2944 8.78914C18.0948 8.58949 17.8734 8.56779 17.6304 8.72404L11.0418 13.1251C10.5904 13.4376 10.343 13.9107 10.2996 14.5444C10.2562 15.178 10.4516 15.7119 10.8856 16.1459ZM5.31266 20.8334C4.93072 20.8334 4.57916 20.7509 4.25798 20.586C3.93679 20.4211 3.68072 20.1737 3.48975 19.8438C3.03836 19.0279 2.69113 18.1815 2.44808 17.3048C2.20502 16.428 2.0835 15.5209 2.0835 14.5834C2.0835 13.1424 2.35693 11.7883 2.90381 10.5209C3.45068 9.25355 4.19287 8.15112 5.13037 7.21362C6.06787 6.27612 7.1703 5.53394 8.43766 4.98706C9.70502 4.44019 11.0592 4.16675 12.5002 4.16675C13.9238 4.16675 15.2606 4.43585 16.5106 4.97404C17.7606 5.51223 18.8543 6.24574 19.7918 7.17456C20.7293 8.10338 21.4759 9.18845 22.0314 10.4298C22.587 11.6711 22.8734 13.0036 22.8908 14.4272C22.9081 15.382 22.7996 16.3152 22.5653 17.2266C22.3309 18.1381 21.9706 19.0105 21.4845 19.8438C21.2936 20.1737 21.0375 20.4211 20.7163 20.586C20.3951 20.7509 20.0436 20.8334 19.6616 20.8334H5.31266Z"
          fill="#2D9CDB"
        />
      </g>
    </svg>
  );
};

export default DashboardIcon;
